"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CPD_TOPICS = exports.CPD_REVIEW_STATUSES = exports.CPD_MODULE_TYPES = void 0;
exports.CPD_MODULE_TYPES = ['video', 'article', 'knowledge_check', 'scorm'];
exports.CPD_REVIEW_STATUSES = ['pending', 'approved', 'rejected'];
exports.CPD_TOPICS = [
    'safeguarding',
    'send_inclusion',
    'inkstep_delivery',
    'general_pedagogy',
    'other',
];
